import {Component, inject, input, OnInit, output, signal} from '@angular/core';
import {AbstractControl, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {InAppMessage} from "../../models/inAppMessage";
import {RepoService} from "../../services/repo.service";
import {NgOptimizedImage} from "@angular/common";
import {HttpClient} from "@angular/common/http";
import {Bu} from "../../models/bu";
import {MatDrawer, MatDrawerContainer} from "@angular/material/sidenav";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatSuffix} from "@angular/material/form-field";
import {MatTimepicker, MatTimepickerInput} from "@angular/material/timepicker";
import {DateAdapter, MatNativeDateModule} from "@angular/material/core";
import {MatInput} from "@angular/material/input";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {urlValidator} from "../../shared/custom-validators";
import {FavoritesAndHistoryComponent} from "../favorites-and-history-drawer/favorites-and-history.component";
import {BuType} from "../../models/bu-types";


@Component({
  selector: 'app-create-in-app-message-dialog',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    NgOptimizedImage,
    MatDrawer,
    MatDrawerContainer,
    MatDatepicker,
    MatDatepickerToggle,
    MatSuffix,
    MatDatepickerInput,
    MatTimepicker,
    MatTimepickerInput,
    MatNativeDateModule,
    FormsModule,
    MatInput,
    MatProgressSpinner,
    FavoritesAndHistoryComponent,
  ],
  templateUrl: './create-in-app-message.component.html',
  styleUrl: './create-in-app-message.component.scss'
})
export class CreateInAppMessageComponent implements OnInit {

  repo = inject(RepoService)
  http = inject(HttpClient)

  loading = signal(false);
  onBackClick = output();
  bus = ["uk", "se", "no", "de"] as BuType[];
  allForm = new FormGroup({
    englishTitle: new FormControl(""),
    swedishTitle: new FormControl(""),
    norwegianTitle: new FormControl(""),
    germanTitle: new FormControl(""),
    englishMessage: new FormControl("", Validators.required),
    swedishMessage: new FormControl("", Validators.required),
    norwegianMessage: new FormControl("", Validators.required),
    germanMessage: new FormControl("", Validators.required),
    englishLabel: new FormControl(""),
    swedishLabel: new FormControl(""),
    norwegianLabel: new FormControl(""),
    germanLabel: new FormControl(""),
    dismissible: new FormControl(false),
    link: new FormControl(false),
    linkLabel: new FormControl(null),
    externalUrl: new FormControl(null, this.validateUrlFormat),
    displayRoute: new FormControl(""),
    versionCondition: new FormControl<number>(0),
    versionNumber: new FormControl(""),
    subscriptionFlexible: new FormControl(false),
    subscriptionEnergy: new FormControl(false),
    subscriptionDropIn: new FormControl(false),
    scheduledStart: new FormControl(false),
    scheduledEnd: new FormControl(false),
    applyForAllBus: new FormControl(false),
    startDate: new FormControl<Date | null>({value: null, disabled: true}),
    startTime: new FormControl<Date | null>({value: null, disabled: true}),
    endDate: new FormControl<Date | null>({value: null, disabled: true}),
    endTime: new FormControl<Date | null>({value: null, disabled: true}),
    os: new FormControl<'Android' | 'iOS' | 'All'>('All'),
  }, urlValidator());
  data = input<{
    bu: BuType,
    currentInAppMessage: InAppMessage,
    allMessages: InAppMessage[]
  }>()
  protected readonly Bu = Bu;
  private readonly _adapter = inject<DateAdapter<unknown, unknown>>(DateAdapter);

  constructor() {

  }

  ngOnInit(): void {
    if (this.data().currentInAppMessage) {
      this.copyCurrentMessage(this.data().currentInAppMessage)

    }
    this._adapter.setLocale('SE-sv')
  }

  copyCurrentMessage(currentInAppMessage: InAppMessage) {

    this.allForm.controls.linkLabel.setValue(currentInAppMessage.linkLabel ?? "")
    this.allForm.controls.externalUrl.setValue(currentInAppMessage.externalUrl ?? "")
    this.allForm.controls.dismissible.setValue(currentInAppMessage.dismissible ?? false)
    this.allForm.controls.displayRoute.setValue(currentInAppMessage.displayRoute ?? "")
    if (currentInAppMessage.subscription?.includes("flexible")) {
      this.allForm.controls.subscriptionFlexible.setValue(true)
    }

    if (currentInAppMessage.subscription?.includes("energy")) {
      this.allForm.controls.subscriptionEnergy.setValue(true)
    }

    if (currentInAppMessage.subscription?.includes("dropIn")) {
      this.allForm.controls.subscriptionDropIn.setValue(true)
    }

    this.allForm.controls.versionCondition.setValue(currentInAppMessage.versionCondition ?? 0)
    this.allForm.controls.versionNumber.setValue(currentInAppMessage.versionNumber ?? "")

    this.allForm.controls.englishTitle.setValue(currentInAppMessage.titles[0] ?? "")
    this.allForm.controls.englishMessage.setValue(currentInAppMessage.messages[0] ?? "")
    this.allForm.controls.englishLabel.setValue(currentInAppMessage.labels[0] ?? "")

    this.allForm.controls.swedishTitle.setValue(currentInAppMessage.titles[1] ?? "")
    this.allForm.controls.swedishMessage.setValue(currentInAppMessage.messages[1] ?? "")
    this.allForm.controls.swedishLabel.setValue(currentInAppMessage.labels[1] ?? "")

    this.allForm.controls.norwegianTitle.setValue(currentInAppMessage.titles[2] ?? "")
    this.allForm.controls.norwegianMessage.setValue(currentInAppMessage.messages[2] ?? "")
    this.allForm.controls.norwegianLabel.setValue(currentInAppMessage.labels[2] ?? "")

    this.allForm.controls.germanTitle.setValue(currentInAppMessage.titles[3] ?? "")
    this.allForm.controls.germanMessage.setValue(currentInAppMessage.messages[3] ?? "")
    this.allForm.controls.germanLabel.setValue(currentInAppMessage.labels[3] ?? "")


    this.allForm.controls.startDate.setValue(currentInAppMessage.startDate)
    this.allForm.controls.endDate.setValue(currentInAppMessage.endDate)

    this.allForm.controls.startTime.setValue(currentInAppMessage.startDate)
    this.allForm.controls.endTime.setValue(currentInAppMessage.endDate)

    if (currentInAppMessage.startDate) {
      this.allForm.controls.startDate.enable();
      this.allForm.controls.startTime.enable();
      this.allForm.controls.scheduledStart.setValue(true)

    } else {
      this.allForm.controls.startDate.disable();
      this.allForm.controls.startTime.disable();
      this.allForm.controls.scheduledStart.setValue(false)
    }

    if (currentInAppMessage.endDate) {
      this.allForm.controls.endDate.enable()
      this.allForm.controls.endTime.enable()
      this.allForm.controls.scheduledEnd.setValue(true)
    } else {
      this.allForm.controls.endDate.disable()
      this.allForm.controls.endTime.disable()
      this.allForm.controls.scheduledEnd.setValue(false)
    }
    this.allForm.controls.os.setValue(currentInAppMessage.os ?? 'All')
  }

  validateUrlFormat(control: AbstractControl): { [key: string]: any } | null {
    if (control.value && !/^((https?):\/\/)(([\da-z.-]+)\.([a-z.]{2,6})([\/\w.-]*)*\/?)(\?.*)?$/.test(control.value)) {
      return {'invalidUrlFormat': true};
    }
    return null;
  }

  async createMessage() {
    let message: InAppMessage | null = null;
    let titles = [this.allForm.value.englishTitle, this.allForm.value.swedishTitle, this.allForm.value.norwegianTitle, this.allForm.value.germanTitle];
    let messages = [this.allForm.value.englishMessage, this.allForm.value.swedishMessage, this.allForm.value.norwegianMessage, this.allForm.value.germanMessage];
    let labels = [this.allForm.value.englishLabel, this.allForm.value.swedishLabel, this.allForm.value.norwegianLabel, this.allForm.value.germanLabel];

    console.log(this.allForm.value.displayRoute)
    if (this.allForm.valid) {
      message = new InAppMessage(null, this.allForm.value.swedishTitle ?? null, titles, this.allForm.value.swedishMessage, messages, labels, this.allForm.value.swedishLabel, this.allForm.value.externalUrl ?? null, this.allForm.value.dismissible ?? true, this.data().bu, this.data().bu, this.allForm.value.displayRoute, new Date(), this.allForm.value.os ?? 'All');
      if (this.allForm.value.applyForAllBus) {
        this.data().allMessages.forEach(m => {
          this.repo.removeInAppMessage(m)
        })


      } else if (this.data().currentInAppMessage != null) {
        await this.repo.removeInAppMessage(this.data().currentInAppMessage);
      }
    }

    if (message) {
      message.subscription = "";

      let start = this.allForm.value.startDate;
      let end = this.allForm.value.endDate;
      if (start != null) {
        start.setHours(this.allForm.value.startTime.getHours())
        start.setMinutes(this.allForm.value.startTime.getMinutes())
        start.setSeconds(0)
      }

      if (end != null) {
        end.setHours(this.allForm.value.endTime.getHours())
        end.setMinutes(this.allForm.value.endTime.getMinutes())
        end.setSeconds(0)
      }

      message.startDate = this.allForm.value.startDate ?? null;
      message.endDate = this.allForm.value.endDate ?? null;

      message.type = message.startDate ? "scheduled" : "active";

      if (this.allForm.value.subscriptionFlexible) {
        message.subscription = "flexible";
      }

      if (this.allForm.value.subscriptionEnergy) {
        message.subscription += "energy";
      }

      if (this.allForm.value.subscriptionDropIn) {
        message.subscription += "dropIn";
      }

      if (message.subscription == "") {
        message.subscription = null;
      }

      if (this.allForm.value.versionCondition > 0 && this.allForm.value.versionNumber.length > 2) {
        message.versionCondition = this.allForm.value.versionCondition;
        message.versionNumber = this.allForm.value.versionNumber;
      }

      if (this.allForm.value.applyForAllBus) {
        for (const bu of this.bus) {
          message.bu = bu;

          //for backward compatibility
          message.locale = bu;
          this.repo.createInAppMessage(message)
        }
      } else {
        this.repo.createInAppMessage(message);
        this.repo.saveInHistory(message)
      }
    }

    this.onBackClick.emit();

  }


  async translateWithAI() {

    this.loading.set(true);

    if (this.allForm.controls.englishMessage.value) {
      await this.translate("en");
    } else if (this.allForm.controls.swedishMessage.value) {

      await this.translate("sv");

    } else if (this.allForm.controls.norwegianMessage.value) {
      await this.translate("no");

    } else if (this.allForm.controls.germanMessage.value) {
      await this.translate("de")

    } else {
      return;
    }

    this.loading.set(false);
  }

  async translate(sourceLanguage: string) {
    let title: string;
    let message: string;
    let label: string;

    console.log("www", sourceLanguage)
    switch (sourceLanguage) {
      case "en":
        title = this.allForm.controls.englishTitle.value;
        message = this.allForm.controls.englishMessage.value;
        label = this.allForm.controls.englishLabel.value;
        break;

      case "sv":
        title = this.allForm.controls.swedishTitle.value;
        message = this.allForm.controls.swedishMessage.value;
        label = this.allForm.controls.swedishLabel.value;
        break;

      case "no":
        title = this.allForm.controls.norwegianTitle.value;
        message = this.allForm.controls.norwegianMessage.value;
        label = this.allForm.controls.norwegianLabel.value;
        break;

      case "de":
        title = this.allForm.controls.germanTitle.value;
        message = this.allForm.controls.germanMessage.value;
        label = this.allForm.controls.germanLabel.value;
        break;
    }

    let translations = await this.repo.translateInAPPMessage(title, message, label)


    this.allForm.controls.englishTitle.setValue(translations.englishTitle)
    this.allForm.controls.englishMessage.setValue(translations.englishMessage)
    this.allForm.controls.englishLabel.setValue(translations.englishLabel ?? "");


    this.allForm.controls.swedishTitle.setValue(translations.swedishTitle)
    this.allForm.controls.swedishMessage.setValue(translations.swedishMessage)
    this.allForm.controls.swedishLabel.setValue(translations.swedishLabel ?? "")

    this.allForm.controls.norwegianTitle.setValue(translations.norwegianTitle)
    this.allForm.controls.norwegianMessage.setValue(translations.norwegianMessage)
    this.allForm.controls.norwegianLabel.setValue(translations.norwegianLabel ?? "")


    this.allForm.controls.germanTitle.setValue(translations.germanTitle)
    this.allForm.controls.germanMessage.setValue(translations.germanMessage)
    this.allForm.controls.germanLabel.setValue(translations.germanLabel ?? "")
  }

  onScheduledStartDateToggled(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value;

    if (selectedValue == "false") {
      this.allForm.controls.startDate.setValue(null)
      this.allForm.controls.startTime.setValue(null)
      this.allForm.controls.startDate.disable()
      this.allForm.controls.startTime.disable()
    } else {

      let defaultStartDate = new Date();
      defaultStartDate.setHours(defaultStartDate.getHours() + 2)
      defaultStartDate.setMinutes(0)
      defaultStartDate.setSeconds(0);
      this.allForm.controls.startDate.setValue(defaultStartDate)
      this.allForm.controls.startTime.setValue(defaultStartDate)
      this.allForm.controls.startDate.enable()
      this.allForm.controls.startTime.enable()
    }
  }


  onScheduledEndDateToggled(event: Event) {
    const selectElement = event.target as HTMLSelectElement;
    const selectedValue = selectElement.value;

    if (selectedValue == "false") {
      this.allForm.controls.endDate.reset(null)
      this.allForm.controls.endTime.reset(null)
      this.allForm.controls.endDate.disable()
      this.allForm.controls.endTime.disable()

    } else {
      let defaultDate = new Date();
      defaultDate.setSeconds(0)
      defaultDate.setDate(defaultDate.getDate() + 1)
      defaultDate.setMinutes(0)

      this.allForm.controls.endDate.setValue(defaultDate)
      this.allForm.controls.endTime.setValue(defaultDate)
      this.allForm.controls.endDate.enable()
      this.allForm.controls.endTime.enable()
    }
  }
}
